// extracted by mini-css-extract-plugin
export default {"name":"UserAccount_name__EEeBa"};